import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  
  import { allOpinion,replyOpinionMessage,delOpinion } from '../../api'
  
  
  
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const search = reactive({ 
    state: "0", 
    type: "0"
  })
  
  
  const loading = ref(false);
  
  const selectedKeys = ref([]);
  
  const dataSource = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([ 
    { title: "图片", key: "imgs", align: "center", customSlot: "imgs" },
    { title: "标题", key: "title", align: "center" },
    { title: "问题", key: "content", align: "center"},
    { title: "类型", key: "type", align: "center", customSlot: "type", width: "150px" },
    { title: "回复信息", key: "reply", align: "center" },
    { title: "账号", key: "userName", align: "center" }, 
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  
  const getAllOpinion = () => {
    loading.value = true;
    var data = { 
        page: page.current, 
        limit: page.limit,
        state: Number(search.state),
        type: Number(search.type)
        }

    allOpinion(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  
  getAllOpinion();
  
  const change = (page: any) => {
      getAllOpinion(); 
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
   
  //搜索
  const searchUser=()=>{
    page.current=1; 
      getAllOpinion();
  }
  
  
//删除
  const deleteComplaint=(row: any)=>{

    data = {"id": row.id};
    delOpinion(JSON.stringify(data) ).then((res: any) => { 
     if (res != "" && res.code == 0) {
       layer.msg("操作成功", { icon : 1, time: 1000});
         getAllOpinion();


     } else {
       layer.msg(res.msg, { icon : 2, time: 1000})
     }
   })
  }


 
var data:any;

const changeState = (row: any) => {
     data = {"id": row.id }; 
    visible11.value = !visible11.value;  
}


//回复信息
const addReviewComplaint=(data:any)=>{

  replyOpinionMessage(data).then((res: any) => {
     
    if (res != "" && res.code == 0) { 
      layer.msg("操作成功", { icon : 1, time: 1000})
        getAllOpinion(); 
    } else {
      layer.msg(res.msg, { icon : 2, time: 1000})
    }
  })

}


const reply =ref("");

const visible11 = ref(false);

const action11 = ref([
    {
        text: "确认",
        callback: () => { 
          data.key=reply.value; 
          addReviewComplaint(JSON.stringify(data));
          visible11.value = !visible11.value;
        }
    },
    {
        text: "取消",
        callback: () => {
          visible11.value = !visible11.value;
        }
    }
])
   
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "类型",
                      prop: "type",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "信息审核"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "订单问题"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "3",
                              label: "商家咨询"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "4",
                              label: "商务合作"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "5",
                              label: "其他"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "未回复"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "已回复"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  imgs: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.imgs.split(','), (img, index) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: index,
                          src: img,
                          onClick: ($event: any) => (_ctx.signleImg(img)),
                          style: {"width":"62.9px","height":"80px","cursor":"pointer"}
                        }, null, 8, _hoisted_2))
                      }), 128))
                    ])
                  ]),
                  type: _withCtx(({ row }) => [
                    (row.type === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "信息审核"))
                      : (row.type === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "订单问题"))
                        : (row.type === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "商家咨询"))
                          : (row.type === 4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "商务合作"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "其他"))
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleteComplaint(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (changeState(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("回复")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '280px'],
      btn: action11.value,
      title: "回复"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_lay_form, {
            model: reply.value,
            ref: "layFormRef11"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_textarea, {
                placeholder: "请输入回复信息",
                modelValue: reply.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((reply).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})